import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { ref } from "vue"
import { useI18n } from "vue-i18n"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxSearchBarQuick',
  setup(__props) {

const { t } = useI18n()
const searchInput = ref("")
const inputPlaceholder = t("sfxSearch.input_placeholder_manager")

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps({
    modelValue: searchInput.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
    class: "col-grow sfx-search-bar-quick",
    placeholder: _unref(inputPlaceholder),
    borderless: "",
    clearable: ""
  }, _ctx.$attrs), {
    append: _withCtx(() => [
      _createVNode(SfxBtnIcon, {
        icon: _unref(Icons).SEARCH
      }, null, 8, ["icon"])
    ]),
    _: 1
  }, 16, ["modelValue", "placeholder"]))
}
}

})